<template>
  <div class="dashboard-index" style="height: 100%">
    <!--  header-->
    <div class="flex-row flex__between">
      <div
        class="
          header-title
          font-size__large
          flex-row flex__left
          color__black
          margin-bottom-10
        "
        v-if="!!user"
      >
        <!-- <span
          class="font-weight__normal font-italic margin-right-5 margin-top-5"
          >Chào mừng,</span
        >
        <h2 class="font-weight__bold">{{ user.fullName }}</h2> -->
      </div>

      <user-header />
    </div>
    <!--  header:end-->

    <div class="style-fullWidth flex-row flex-right__top" style="height: 100%">
      <!--  main-->
      <div class="cards-area main-content-dashboard" style="height: 100%">
        <vue-perfect-scrollbar class="scroll-area">
          <el-row :gutter="24">
            <el-col :span="24">
              <summary-card :dashboards="dashboards" :dataVanThu="dataVanThu" />
              <summary-card-van-thu :dataVanThu="dataVanThu" />
              <summary-card-hanh-chinh
                v-if="isVisibleHanhChinh && hasHanhChinhPermission"
                :isVisiblePhongHop="isVisiblePhongHop"
                :isVisibleDieuXe="isVisibleDieuXe"
                :isVisibleLichTuan="isVisibleLichTuan"
                :isQuanLyPhongHop="isQuanLyPhongHop"
                :isQuanLyDieuXe="isQuanLyDieuXe"
                :isTongHopLichTuan="isTongHopLichTuan"
                :meetingRoomDaDangKy="meetingRoomDaDangKy"
                :meetingRoomChoDuyet="meetingRoomChoDuyet"
                :meetingRoomDaDuyet="meetingRoomDaDuyet"
                :meetingRoomHuy="meetingRoomHuy"
                :driverRequestDaDangKy="driverRequestDaDangKy"
                :driverRequestChoDuyet="driverRequestChoDuyet"
                :driverRequestDaDuyet="driverRequestDaDuyet"
                :driverRequestHuy="driverRequestHuy"
                :weeklyScheduleDaBanHanh="weeklyScheduleDaBanHanh"
                :weeklyScheduleChuaDuyet="weeklyScheduleChuaDuyet"
                :weeklyScheduleDaDangKy="weeklyScheduleDaDangKy"
                :weeklyScheduleHuy="weeklyScheduleHuy"
              />
              <summary-card-cong-viec
                v-if="checkCVToiGiao() || checkCVDuocGiao()"
                :dataCVDaGiao="dataCVDaGiao"
                :dataCVDuocGiao="dataCVDuocGiao"
              />
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col
              v-if="isVisibleIncommingDoc"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <doc-in-dashboard-card-v2
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Văn bản đến'"
                  :docs="incomingDocs"
                  :docsCount="incomingDocsCount"
                  :unreadDocCount="unreadIncomingDocsCount"
                  :getItemKeyFn="
                    (item) => item.vbIncomingDocUserViewKey.vbDocUserId
                  "
                  @viewDetail="viewDetailIncomingDoc"
                  @viewMore="viewMoreIncomingDoc"
                >
                </doc-in-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="isVisibleOutgoingDoc"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <doc-out-dashboard-card-v2
                  :cardTitle="'Văn bản dự thảo'"
                  :docs="outgoingDocs"
                  :docsCount="outgoingDocsCount"
                  :unreadDocCount="unreadOutgoingDocsCount"
                  :getItemKeyFn="
                    (item) => item.vbOutgoingDocUserViewKey.vbDocUserId
                  "
                  @viewDetail="viewDetailOutgoingDoc"
                  @viewMore="viewMorelOutgoingDoc"
                >
                </doc-out-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="isVisibleBanHanhOutgoingDoc"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <doc-out-dashboard-card-v2
                  :cardTitle="'Văn bản đã phát hành'"
                  :docs="banHanhOutgoingDocs"
                  :docsCount="banHanhOutgoingDocsCount"
                  :getItemKeyFn="
                    (item) => item.vbOutgoingDocUserViewKey.vbDocUserId
                  "
                  @viewDetail="viewDetailBanHanhOutgoingDoc"
                  @viewMore="viewMorelBanHanhOutgoingDoc"
                >
                </doc-out-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="isVisibleChoBanHanh"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <doc-out-dashboard-card-v2
                  :cardTitle="'Văn bản chờ ban hành'"
                  :docs="vanBanChoBanHanh"
                  :docsCount="vanBanChoBanHanhCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailChoBanHanh"
                  @viewMore="viewMoreChoBanHanh"
                >
                </doc-out-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="isVisibleChoTiepNhan"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <doc-in-dashboard-card-v2
                  :cardTitle="'Văn bản chờ tiếp nhận'"
                  :docs="vanBanChoTiepNhan"
                  :docsCount="vanBanChoTiepNhanCount"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailChoTiepNhan"
                  @viewMore="viewMoreChoTiepNhan"
                >
                </doc-in-dashboard-card-v2>
              </div>
            </el-col>
            <el-col
              v-if="checkCVDuocGiao()"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <job-dashboard-card
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Công việc được giao'"
                  :jobs="returnListJob(dataCVDuocGiao)"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewListCVDuocGiao"
                >
                </job-dashboard-card>
              </div>
            </el-col>
            <el-col
              v-if="checkCVToiGiao()"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <job-dashboard-card
                  :userDeptRoles="userDeptRoles"
                  :cardTitle="'Công việc tôi giao'"
                  :jobs="returnListJob(dataCVDaGiao)"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewListCVDaGiao"
                >
                </job-dashboard-card>
              </div>
            </el-col>
            <!-- <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              v-if="isVisibleVanBanMau"
            >
              <div class="card-area">
                <share-library-dashboard-card-v2
                  :cardTitle="'Văn bản mẫu'"
                  :shareLibDocs="shareLibDocs"
                  @viewMore="viewMoreShareLibDoc"
                >
                </share-library-dashboard-card-v2>
              </div>
            </el-col> -->
            <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" v-if="isVisibleHanhChinh">
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Phòng họp đã đăng ký'"
                  :data="
                    meetingRoomDaDangKy && meetingRoomDaDangKy.datas
                      ? meetingRoomDaDangKy.datas
                      : []
                  "
                  :count="
                    meetingRoomDaDangKy ? meetingRoomDaDangKy.phopCount : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailMeetingRoom"
                  @viewMore="viewMoreMeetingWaiting"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              v-if="isQuanLyPhongHop && isVisibleHanhChinh"
            >
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Phòng họp chờ phê duyệt'"
                  :data="
                    meetingRoomChoDuyet &&
                    meetingRoomChoDuyet.data &&
                    meetingRoomChoDuyet.data.datas
                      ? meetingRoomChoDuyet.data.datas
                      : []
                  "
                  :count="
                    meetingRoomChoDuyet ? meetingRoomChoDuyet.phopCount : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailMeetingRoom"
                  @viewMore="viewMoreMeetingWaiting"
                >
                </admin-dashboard-card>
              </div>
            </el-col>
            <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" v-if="isVisibleHanhChinh">
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Phòng họp đã phê duyệt'"
                  :data="
                    meetingRoomDaDuyet && meetingRoomDaDuyet.datas
                      ? meetingRoomDaDuyet.datas
                      : []
                  "
                  :count="meetingRoomDaDuyet ? meetingRoomDaDuyet.phopCount : 0"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailMeetingRoom"
                  @viewMore="viewMoreMeetingAccepted"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
            <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" v-if="isVisibleHanhChinh">
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Phòng họp huỷ yêu cầu'"
                  :data="
                    meetingRoomHuy && meetingRoomHuy.datas
                      ? meetingRoomHuy.datas
                      : []
                  "
                  :count="meetingRoomHuy ? meetingRoomHuy.phopCount : 0"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailMeetingRoom"
                  @viewMore="viewMoreMeetingCancelled"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
            <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" v-if="isVisibleHanhChinh">
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Điều xe đã đăng ký'"
                  :data="
                    driverRequestDaDangKy && driverRequestDaDangKy.datas
                      ? driverRequestDaDangKy.datas
                      : []
                  "
                  :count="
                    driverRequestDaDangKy
                      ? driverRequestDaDangKy.dieuXeCount
                      : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailDriverRequest"
                  @viewMore="viewMoreDriverRequestWaiting"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              v-if="isQuanLyDieuXe && isVisibleHanhChinh"
            >
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Điều xe chờ phê duyệt'"
                  :data="
                    driverRequestChoDuyet &&
                    driverRequestChoDuyet.data &&
                    driverRequestChoDuyet.data.datas
                      ? driverRequestChoDuyet.data.datas
                      : []
                  "
                  :count="
                    driverRequestChoDuyet
                      ? driverRequestChoDuyet.dieuXeCount
                      : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailDriverRequest"
                  @viewMore="viewMoreDriverRequestWaiting"
                >
                </admin-dashboard-card>
              </div>
            </el-col>
            <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" v-if="isVisibleHanhChinh">
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Điều xe đã phê duyệt'"
                  :data="
                    driverRequestDaDuyet && driverRequestDaDuyet.datas
                      ? driverRequestDaDuyet.datas
                      : []
                  "
                  :count="
                    driverRequestDaDuyet ? driverRequestDaDuyet.dieuXeCount : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailDriverRequest"
                  @viewMore="viewMoreDriverRequestAccepted"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
            <!-- <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="8" v-if="isVisibleHanhChinh">
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Điều xe huỷ yêu câu'"
                  :data="
                    driverRequestHuy && driverRequestHuy.datas
                      ? driverRequestHuy.datas
                      : []
                  "
                  :count="driverRequestHuy ? driverRequestHuy.dieuXeCount : 0"
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailDriverRequest"
                  @viewMore="viewMoreDriverRequestCancelled"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
            <!-- <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Lịch tuần đã đăng ký'"
                  :data="
                    weeklyScheduleDaDangKy &&
                    weeklyScheduleDaDangKy.hcCaseCalendars
                      ? weeklyScheduleDaDangKy.hcCaseCalendars
                      : []
                  "
                  :count="
                    weeklyScheduleDaDangKy
                      ? weeklyScheduleDaDangKy.countLichTuan
                      : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailWeeklySchedule"
                  @viewMore="viewMoreWeeklyScheduleDaBanHanh"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
            <!-- <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Lịch tuần đã phê duyệt'"
                  :data="
                    weeklyScheduleDaBanHanh &&
                    weeklyScheduleDaBanHanh.hcCaseCalendars
                      ? weeklyScheduleDaBanHanh.hcCaseCalendars
                      : []
                  "
                  :count="
                    weeklyScheduleDaBanHanh
                      ? weeklyScheduleDaBanHanh.countLichTuan
                      : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailWeeklySchedule"
                  @viewMore="viewMoreWeeklyScheduleDaBanHanh"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              v-if="isTongHopLichTuan"
            >
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Lịch tuần chờ phê duyệt'"
                  :data="
                    weeklyScheduleChuaDuyet &&
                    weeklyScheduleChuaDuyet.data &&
                    weeklyScheduleChuaDuyet.data.hcCaseCalendars
                      ? weeklyScheduleChuaDuyet.data.hcCaseCalendars
                      : []
                  "
                  :count="
                    weeklyScheduleChuaDuyet
                      ? weeklyScheduleChuaDuyet.countLichTuan
                      : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailWeeklySchedule"
                  @viewMore="viewMoreWeeklyScheduleChuaDuyet"
                >
                </admin-dashboard-card>
              </div>
            </el-col>
            <!-- <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
            >
              <div class="card-area">
                <admin-dashboard-card
                  :cardTitle="'Lịch tuần huỷ yêu cầu'"
                  :data="
                    weeklyScheduleHuy && weeklyScheduleHuy.hcCaseCalendars
                      ? weeklyScheduleHuy.hcCaseCalendars
                      : []
                  "
                  :count="
                    weeklyScheduleHuy ? weeklyScheduleHuy.countLichTuan : 0
                  "
                  :getItemKeyFn="(item) => item.id"
                  @viewDetail="viewDetailWeeklySchedule"
                  @viewMore="viewMoreWeeklyScheduleChuaDuyet"
                >
                </admin-dashboard-card>
              </div>
            </el-col> -->
          </el-row>
        </vue-perfect-scrollbar>
      </div>
      <!--  main:end-->
      <!--  right-->
      <div class="notification-area">
        <notifications-card-v2
          :cardTitle="'Thông báo'"
          :notifis="notifications"
          :notifysCount="notificationsCount"
          :unreadNotifysCount="notificationsUnreadCount"
        >
        </notifications-card-v2>
      </div>
      <!--  right:end-->
    </div>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import headerTemplate from "../../components/header/main-header.vue";
import dashBoardService from "../../services/dashBoardService";
import h from "../../services/h";
import SummaryCard from "./SummaryCard";
import SummaryCardVanThu from "./SummaryCardVanThu";
import SummaryCardHanhChinh from "./SummaryCardHanhChinh";
import SummaryCardLichTuan from "./SummaryCardLichTuan";
import IncomingDocsCard from "./IncomingDocsCard";
import ShareLibraryCard from "./ShareLibraryCard";
import OutgoingDocsCard from "./OutgoingDocsCard";
import CongViecCard from "./CongViecCard";
import NotifyCard from "./NotifyCard";
import ChoBanHanhCard from "./ChoBanHanhCard";
import ChoTiepNhanCard from "./ChoTiepNhanCard";
import constants from "../../constants";
import { EventBus } from "../../event-bus";
import menuConfigService from "../../services/menuConfigService";
import NotificationsCardV2 from "./notifications-card-v2";
import DashboardIndicators from "./dashboard-indicators";
import DocInDashboardCardV2 from "./doc-in-dashboard-card-v2";
import DocOutDashboardCardV2 from "./doc-out-dashboard-card-v2";
import ShareLibraryDashboardCardV2 from "./share-library-dashboard-card-v2";
import UserHeader from "../../components/header/user-header";
import AdminDashboardCard from "./AdminDashboardCard";
import SummaryCardCongViec from "./SummaryCardCongViec.vue";
import JobDashboardCard from "./job-dashboard-card.vue";

export default {
  name: "dashboard",
  components: {
    UserHeader,
    ShareLibraryDashboardCardV2,
    DocOutDashboardCardV2,
    DocInDashboardCardV2,
    DashboardIndicators,
    NotificationsCardV2,
    ShareLibraryCard,
    SummaryCard,
    SummaryCardHanhChinh,
    SummaryCardLichTuan,
    IncomingDocsCard,
    OutgoingDocsCard,
    JobDashboardCard,
    CongViecCard,
    NotifyCard,
    ChoBanHanhCard,
    ChoTiepNhanCard,
    listTemplate: () => import("../common/list"),
    VuePerfectScrollbar,
    headerTemplate,
    cardTemplate: () => import("../common/cardTemplate.vue"),
    AdminDashboardCard,
    SummaryCardVanThu,
    SummaryCardCongViec,
  },
  data() {
    return {
      notifications: [],
      notificationsCount: null,
      notificationsUnreadCount: null,

      incomingDocs: [],
      incomingDocsCount: null,
      unreadIncomingDocsCount: null,

      shareLibDocs: [],

      vanBanChoBanHanh: [],
      vanBanChoBanHanhCount: null,

      vanBanChoTiepNhan: [],
      vanBanChoTiepNhanCount: null,

      outgoingDocs: [],
      outgoingDocsCount: null,
      unreadOutgoingDocsCount: null,

      banHanhOutgoingDocs: [],
      banHanhOutgoingDocsCount: null,

      listDashBoard: [],
      dashboards: [],
      menuConfigs: [],
      checkedMenuCodes: [],
      isVisibleIncommingDoc: false,
      isVisibleOutgoingDoc: false,
      isVisibleBanHanhOutgoingDoc: false,
      isVisibleCongViec: false,
      // isVisibleHanhChinh: false,
      isVisibleChoBanHanh: false,
      isVisibleChoTiepNhan: false,
      userDeptRoleIdForIncommingDoc: null,
      userDeptRoleIdForOutgoingDoc: null,
      userDeptRoleIdForBanHanhOutgoingDoc: null,
      userDeptRoleIdForCongViec: null,
      userDeptRoleIdForHanhChinh: null,
      userDeptRoleIdForChoBanHanh: null,
      userDeptRoleIdForChoTiepNhan: null,

      // isVisibleVanBanMau: false,
      isVisiblePhongHop: false,
      isVisibleDieuXe: false,
      isVisibleLichTuan: false,

      // Dữ liệu báo cáo hành chính
      meetingRoomDaDangKy: { data: [], phopCount: 0 },
      meetingRoomChoDuyet: { data: [], phopCount: 0 },
      meetingRoomDaDuyet: { data: [], phopCount: 0 },
      meetingRoomHuy: { data: [], phopCount: 0 },
      driverRequestDaDangKy: { data: [], dieuXeCount: 0 },
      driverRequestChoDuyet: { data: [], dieuXeCount: 0 },
      driverRequestDaDuyet: { data: [], dieuXeCount: 0 },
      driverRequestHuy: { data: [], dieuXeCount: 0 },
      weeklyScheduleDaDangKy: { data: [], countLichTuan: 0 },
      weeklyScheduleDaBanHanh: { data: [], countLichTuan: 0 },
      weeklyScheduleChuaDuyet: { data: [], countLichTuan: 0 },
      weeklyScheduleHuy: { data: [], countLichTuan: 0 },

      // Dữ liệu báo cáo văn thư
      dataVanThu: [],

      // Dữ liệu công việc
      dataCVDaGiao: {},
      dataCVDuocGiao: {},
    };
  },

  watch: {
    notiStore() {
      this.notifications = this.notiStore;
      this.notificationsUnreadCount =
        this.$store.getters.notificationsUnreadCount;
      // this.loadNotificationsDashBoard();
    },
  },

  computed: {
    notiStore() {
      return this.$store.getters.notifies;
    },
    hasHanhChinhPermission() {
      return this.$store.getters.enableMenuCodes.find(
        (item) =>
          item === constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOP ||
          item === constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXE ||
          item === constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN
      );
    },
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    },
    userDeptRolesId() {
      return this.$store.getters.userDeptRoleId;
    },
    user() {
      return this.$store.getters.user;
    },
    isQuanLyPhongHop() {
      return (
        this.userDeptRoles &&
        this.userDeptRoles.find(
          (item) => item.roleCode === constants.ROLE.CODE.PHONG_HOP.QL_PHONG_HOP
        )
      );
    },
    isQuanLyDieuXe() {
      return (
        this.userDeptRoles &&
        this.userDeptRoles.find(
          (item) => item.roleCode === constants.ROLE.CODE.DIEU_XE.QUAN_LY_XE
        )
      );
    },
    isTongHopLichTuan() {
      return (
        this.userDeptRoles &&
        this.userDeptRoles.find(
          (item) => item.roleCode === constants.ROLE.CODE.TONG_HOP_LICH_TUAN
        )
      );
    },
    isVanThu() {
      return (
        this.userDeptRoles &&
        this.userDeptRoles.find(
          (item) => item.roleCode === constants.ROLE.CODE.VAN_THU
        )
      );
    },
    isVisibleHanhChinh() {
      return (
        this.userDeptRoles &&
        this.userDeptRoles.find(
          (item) =>
            item.roleCode !== constants.ROLE.CODE.VAN_THU &&
            item.roleCode !== constants.ROLE.CODE.ADMIN
        )
      );
    },
  },

  created() {
    if(this.userDeptRoles && this.userDeptRoles.length) {
      this.loadData();
      this.loadIncomingDocsDashBoard();
      this.loadOutgoingDocsDashBoard();
      this.loadBanHanhOutgoingDocsDashBoard();
      this.loadVanBanChoTiepNhan();
      if (this.notiStore && this.notiStore.length) {
        this.notifications = this.notiStore;
        this.notificationsUnreadCount =
          this.$store.getters.notificationsUnreadCount;
      }
      this.loadNotificationsDashBoard();
      if (this.checkCVToiGiao()) {
        this.loadDataCVDaGiao();
      }
      if (this.checkCVDuocGiao()) {
        this.loadDataCVDuocGiao();
      }
      if (this.isVisibleHanhChinh) {
        this.loadHanhChinhAndLichTuan();
      }
      if (this.isVanThu) {
        this.loadDataVanThu();
        this.loadVanBanChoBanHanh();
      }
    }
  },

  methods: {
    checkCVToiGiao() {
      return (
        (this.$store.getters.enableMenuCodes || []).indexOf(
          constants.MENU_LIST.CONGVIEC_GIAO
        ) !== -1
      );
    },
    checkCVDuocGiao() {
      return (
        (this.$store.getters.enableMenuCodes || []).indexOf(
          constants.MENU_LIST.CONGVIEC_GIAO
        ) !== -1
      );
    },
    loadData() {
      dashBoardService.getData().then((response) => {
        this.dashboards = response.data;
        this.setVisible();
      });
    },
    loadDataVanThu() {
      dashBoardService.getDashBoardVanThu().then((response) => {
        if (response.data && response.data.length) {
          this.dataVanThu = response.data;
        }
      });
    },

    loadDataCVDaGiao() {
      dashBoardService.getDashBoardCongViecDagiao().then((res) => {
        this.dataCVDaGiao = res.data;
      });
    },

    loadDataCVDuocGiao() {
      dashBoardService.getDashBoardCongViecDuocGiao().then((res) => {
        this.dataCVDuocGiao = res.data;
      });
    },

    loadHanhChinhAndLichTuan() {
      // state=chopheduyet_state type=1 --- đã gửi đăng ký
      // state=chopheduyet_state --- chờ phê duyệt
      // state=dapheduyet_state  --- dã phê duyệt
      // state=huyyeucau_state   --- hủy
      // Lấy dữ liệu phòng họp
      if (this.isQuanLyPhongHop) {
        this.loadMeetingRoom("chopheduyet_state");
      }
      this.loadMeetingRoom("chopheduyet_state", 1);
      this.loadMeetingRoom("dapheduyet_state");
      this.loadMeetingRoom("huyyeucau_state");

      // Lấy dữ liệu điều xe
      if (this.isQuanLyDieuXe) {
        this.loadDriverRequest("chopheduyet_state");
      }
      this.loadDriverRequest("chopheduyet_state", 1);
      this.loadDriverRequest("dapheduyet_state");
      this.loadDriverRequest("huyyeucau_state");

      // Lấy dữ liệu lịch tuần
      if (this.isTongHopLichTuan) {
        this.loadWeeklySchedule("Chưa phê duyệt");
      }
      this.loadWeeklySchedule("Chưa phê duyệt", 1);
      this.loadWeeklySchedule("Đã ban hành");
      this.loadWeeklySchedule("Hủy yêu cầu");
    },
    viewMorelBanHanhOutgoingDoc() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.CHUYEN_VIEN) {
          this.userDeptRoleIdForBanHanhOutgoingDoc = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForBanHanhOutgoingDoc
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForBanHanhOutgoingDoc,
      });
      this.$router.push({
        name: "vbDaPhatHanhNew",
        params: { userDeptRoleId: this.userDeptRoleIdForBanHanhOutgoingDoc },
      });
    },

    viewMorelOutgoingDoc() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.CHUYEN_VIEN) {
          this.userDeptRoleIdForOutgoingDoc = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForOutgoingDoc
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForOutgoingDoc,
      });
      this.$router.push({
        name: "vbDuThaoNew",
        params: { userDeptRoleId: this.userDeptRoleIdForOutgoingDoc },
      });
    },

    viewMoreIncomingDoc() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.CHUYEN_VIEN) {
          this.userDeptRoleIdForIncommingDoc = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForIncommingDoc
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForIncommingDoc,
      });
      this.$router.push({
        name: "vbDenChoXuLy",
        params: {
          userDeptRoleId: this.userDeptRoleIdForIncommingDoc,
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
      });
    },

    viewDetailIncomingDoc(event) {
      let item = event.doc;
      let userDeptRole = h.find(
        this.userDeptRoles,
        (userDeptRoleItem) =>
          userDeptRoleItem.userId == item.userId &&
          userDeptRoleItem.deptId == item.vbDocUserDeptId &&
          userDeptRoleItem.roleId == item.vbDocUserRoleId
      );
      this.$store.commit("changeUserDeptRole", userDeptRole.id);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRole.id,
      });

      userDeptRole &&
        this.$router.push({
          name: "vbDenChoXuLyDetail",
          params: {
            userDeptRoleId: userDeptRole.id,
            id: item.vbIncomingDocUserViewKey.id,
            dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
          },
          query: { vbDocProcessId: item.vbDocUserVbDocProcessId },
        });
    },

    viewDetailOutgoingDoc(event) {
      let item = event.doc;
      let userDeptRole = h.find(
        this.userDeptRoles,
        (userDeptRoleItem) =>
          userDeptRoleItem.userId == item.userId &&
          userDeptRoleItem.deptId == item.vbDocUserDeptId &&
          userDeptRoleItem.roleId == item.vbDocUserRoleId
      );

      if (!userDeptRole) return;
      this.$store.commit("changeUserDeptRole", userDeptRole.id);
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: userDeptRole.id,
      });

      if (
        item.status == constants.OUTGOING_DOC_STATUS.TAOMOI ||
        (item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI &&
          item.creatorId == this.userId) ||
        (item.status == constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH &&
          item.creatorId == this.userId)
      ) {
        this.$router.push({
          name: "vbDuThaoNewEdit",
          params: {
            userDeptRoleId: userDeptRole.id,
            id: item.vbOutgoingDocUserViewKey.id,
          },
        });
      } else {
        this.$router.push({
          name: "vbDuThaoNewDetail",
          params: {
            userDeptRoleId: userDeptRole.id,
            id: item.vbOutgoingDocUserViewKey.id,
          },
          query: { vbDocProcessId: item.vbDocUserVbDocProcessId },
        });
      }
    },

    viewDetailBanHanhOutgoingDoc(event) {
      let item = event.doc;
      if (this.userDeptRole.roleCode === "vanthu") {
        this.$router.replace({
          name: "vbDaBanHanhDetail",
          params: { id: item.vbOutgoingDocUserViewKey.id },
          query: { vbDocProcessId: item.vbDocUserVbDocProcessId },
        });
      } else {
        this.$router.replace({
          name: "vbDaPhatHanhNewDetail",
          params: { id: item.vbOutgoingDocUserViewKey.id },
          query: { vbDocProcessId: item.vbDocUserVbDocProcessId },
        });
      }
    },

    viewDetailChoBanHanh(event) {
      let item = event.doc;
      this.$router.replace({
        name: "vbChoBanHanhDetail",
        params: { id: item.id, userDeptRoleId: this.userDeptRolesId },
        query: this.$route.query,
      });
    },

    viewDetailChoTiepNhan(event) {
      let item = event.doc;
      this.$router.replace({
        name: "vbChoTiepNhanDetailEditable",
        params: { id: item.id },
        query: this.$route.query,
      });
    },

    viewDetailMeetingRoom(event) {
      let item = event.doc;
      this.$store.commit("changeUserDeptRole", this.isQuanLyPhongHop.id);
      this.$router.replace({
        name: "adminstration-detail",
        params: {
          id: item.caseMasterId,
          userDeptRoleId: this.isQuanLyPhongHop.id,
        },
        query: this.$route.query,
      });
    },

    viewDetailDriverRequest(event) {
      let item = event.doc;
      this.$store.commit("changeUserDeptRole", this.isQuanLyDieuXe.id);
      this.$router.replace({
        name: "adminstration-getCarDetail",
        params: {
          id: item.hcCaseMasterId,
          userDeptRoleId: this.isQuanLyDieuXe.id,
        },
        query: this.$route.query,
      });
    },

    viewDetailWeeklySchedule(event) {
      let item = event.doc;
      this.$store.commit("changeUserDeptRole", this.isTongHopLichTuan.id);
      this.$router.replace({
        name: "adminstration-regiscalendarweek-detail",
        params: {
          id: item.caseMasterId,
          userDeptRoleId: this.isTongHopLichTuan.id,
        },
        query: this.$route.query,
      });
    },

    viewMoreChoBanHanh() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.VAN_THU) {
          this.userDeptRoleIdForChoBanHanh = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForChoBanHanh
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForChoBanHanh,
      });
      this.$router.push({
        name: "vbChoBanHanh",
        params: {
          userDeptRoleId: this.userDeptRoleIdForChoBanHanh,
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
      });
    },

    viewMoreChoTiepNhan() {
      h.each(this.userDeptRoles, (userDeptRole) => {
        if (userDeptRole.roleCode == constants.ROLE.CODE.VAN_THU) {
          this.userDeptRoleIdForChoTiepNhan = userDeptRole.id;
        }
      });
      this.$store.commit(
        "changeUserDeptRole",
        this.userDeptRoleIdForChoTiepNhan
      );
      EventBus.$emit(constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE, {
        userDeptRoleId: this.userDeptRoleIdForChoTiepNhan,
      });
      this.$router.push({
        name: "vbChoTiepNhan",
        params: {
          userDeptRoleId: this.userDeptRoleIdForChoTiepNhan,
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
      });
    },

    viewMoreShareLibDoc() {
      this.$router.push({
        name: "ThuVienDungChung",
        params: {
          userDeptRoleId: this.userDeptRoleIdForChoTiepNhan,
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
      });
    },

    viewMoreMeetingWaiting() {
      this.$router.push({
        name: "adminstration-index",
        params: {
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
        query: { state: "chopheduyet_state" },
      });
    },

    viewMoreMeetingAccepted() {
      this.$router.push({
        name: "adminstration-index",
        params: {
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
        query: { state: "dapheduyet_state" },
      });
    },

    viewMoreMeetingCancelled() {
      this.$router.push({
        name: "adminstration-index",
        params: {
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
        query: { state: "huyyeucau_state" },
      });
    },

    viewMoreDriverRequestWaiting() {
      this.$router.push({
        name: "adminstration-getCar",
        params: {
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
        query: { state: "chopheduyet_state" },
      });
    },

    viewMoreDriverRequestAccepted() {
      this.$router.push({
        name: "adminstration-getCar",
        params: {
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
        query: { state: "dapheduyet_state" },
      });
    },

    viewMoreDriverRequestCancelled() {
      this.$router.push({
        name: "adminstration-getCar",
        params: {
          dateRange: constants.DATE_QUICK_FILTER.CODE.NAM_NAY,
        },
        query: { state: "huyyeucau_state" },
      });
    },

    viewMoreWeeklyScheduleDaBanHanh() {
      this.$store.commit("setCalendarStatusFilter", {
        id: constants.HC_CALENDAR.APPROVE_STATUS.DA_BAN_HANH,
        name: "Đã ban hành",
        level: 3,
      });
      this.$router.push({
        name: "adminstration-regiscalendarweek",
      });
    },

    viewMoreWeeklyScheduleChuaDuyet() {
      this.$store.commit("setCalendarStatusFilter", {
        id: constants.HC_CALENDAR.APPROVE_STATUS.CHUA_PHE_DUYET,
        name: "Chưa phê duyệt",
        level: 1,
      });
      this.$router.push({
        name: "adminstration-regiscalendarweek",
      });
    },

    loadIncomingDocsDashBoard() {
      dashBoardService
        .getIncomingDocsDashBoard({ page: 0, size: 10, sort: "docDate,desc" })
        .then((response) => {
          let incomingDocsDashBoard = response.data;
          this.incomingDocs = incomingDocsDashBoard.docs;
          this.incomingDocsCount = incomingDocsDashBoard.docsCount;
          this.unreadIncomingDocsCount = incomingDocsDashBoard.unreadDocsCount;
        });
    },
    /* loadShareLibDocsDashBoard() {
      dashBoardService
        .getShareLibDocsDashBoard({ page: 0, size: 10, sort: "title,asc" })
        .then((response) => {
          let shareLibDocsDashBoard = response.data;
          this.shareLibDocs = shareLibDocsDashBoard.lstVShareLib;
        });
    }, */

    loadVanBanChoBanHanh() {
      dashBoardService
        .getVanBanChoBanHanhDashBoard({
          page: 0,
          size: 10,
          sort: "docDate,desc",
        })
        .then((response) => {
          let vanBanChoBanHanhDashBoard = response.data;
          this.vanBanChoBanHanh = vanBanChoBanHanhDashBoard.docs;
          this.vanBanChoBanHanhCount = vanBanChoBanHanhDashBoard.docsCount;
        });
    },

    loadMeetingRoom(state, type) {
      // state=chopheduyet_state type=1 --- đã gửi đăng ký
      // state=chopheduyet_state        --- chờ phê duyệt
      // state=dapheduyet_state         --- dã phê duyệt
      // state=huyyeucau_state          --- hủy
      let data = {
        flowCode: "PHONG_HOP",
        state,
        page: 0,
        size: 10,
        sort: "updateTime,desc",
      };
      if (type) {
        data.type = type;
      }
      dashBoardService.getMeetingRoomDashBoard(data).then((res) => {
        this.setStateForMeetingRoom(state, type, res.data);
      });
    },

    setStateForMeetingRoom(state, type, data) {
      if (state === "chopheduyet_state") {
        if (type) {
          // type=1 - Trạng thái đã đăng ký
          // Bỏ vai trò quản lý cho trạng thái chờ phê duyệt
          this.meetingRoomDaDangKy.data = this.isQuanLyPhongHop
            ? data.filter(
                (item) =>
                  item.userDeptRoleView.id !== this.isQuanLyPhongHop.id &&
                  item.phopCount > 0
              )
            : data.filter((item) => item.phopCount > 0);
          this.meetingRoomDaDangKy.phopCount =
            this.meetingRoomDaDangKy.data.reduce(
              (acc, cur) => acc + cur.phopCount,
              0
            );
        } else if (data && data.length) {
          this.meetingRoomChoDuyet.data = data[0];
          this.meetingRoomChoDuyet.phopCount =
            this.meetingRoomChoDuyet.data.phopCount;
        }
      } else if (state === "dapheduyet_state") {
        this.meetingRoomDaDuyet.data = data.filter(
          (item) => item.phopCount > 0
        );
        this.meetingRoomDaDuyet.phopCount = this.meetingRoomDaDuyet.data.reduce(
          (acc, cur) => acc + cur.phopCount,
          0
        );
      } else if (state === "huyyeucau_state") {
        // Bỏ vai trò quản lý cho trạng thái huỷ
        this.meetingRoomHuy.data = this.isQuanLyPhongHop
          ? data.filter(
              (item) =>
                item.userDeptRoleView.id !== this.isQuanLyPhongHop.id &&
                item.phopCount > 0
            )
          : data.filter((item) => item.phopCount > 0);
        this.meetingRoomHuy.phopCount = this.meetingRoomHuy.data.reduce(
          (acc, cur) => acc + cur.phopCount,
          0
        );
      }
    },

    setStateForDriverRequest(state, type, data) {
      if (state === "chopheduyet_state") {
        if (type) {
          // Bỏ vai trò quản lý cho trạng thái chờ phê duyệt
          this.driverRequestDaDangKy.data = this.isQuanLyDieuXe
            ? data.filter(
                (item) =>
                  item.userDeptRoleView.id !== this.isQuanLyDieuXe.id &&
                  item.dieuXeCount > 0
              )
            : data.filter((item) => item.dieuXeCount > 0);
          this.driverRequestDaDangKy.dieuXeCount =
            this.driverRequestDaDangKy.data.reduce(
              (acc, cur) => acc + cur.dieuXeCount,
              0
            );
        } else if (data && data.length) {
          this.driverRequestChoDuyet.data = data[0];
          this.driverRequestChoDuyet.dieuXeCount =
            this.driverRequestChoDuyet.data.dieuXeCount;
        }
      } else if (state === "dapheduyet_state") {
        this.driverRequestDaDuyet.data = data.filter(
          (item) => item.dieuXeCount > 0
        );
        this.driverRequestDaDuyet.dieuXeCount =
          this.driverRequestDaDuyet.data.reduce(
            (acc, cur) => acc + cur.dieuXeCount,
            0
          );
      } else if (state === "huyyeucau_state") {
        // Bỏ vai trò quản lý cho trạng thái huỷ
        this.driverRequestHuy.data = this.isQuanLyDieuXe
          ? data.filter(
              (item) =>
                item.userDeptRoleView.id !== this.isQuanLyDieuXe.id &&
                item.dieuXeCount > 0
            )
          : data.filter((item) => item.dieuXeCount > 0);
        this.driverRequestHuy.dieuXeCount = this.driverRequestHuy.data.reduce(
          (acc, cur) => acc + cur.dieuXeCount,
          0
        );
      }
    },

    setStateForWeeklySchedule(state, type, data) {
      if (state === "Đã ban hành") {
        this.weeklyScheduleDaBanHanh.data = data.filter(
          (item) => item.countLichTuan > 0
        );
        this.weeklyScheduleDaBanHanh.countLichTuan = data.reduce(
          (acc, cur) => acc + cur.countLichTuan,
          0
        );
      } else if (state === "Chưa phê duyệt") {
        if (type) {
          this.weeklyScheduleDaDangKy.data = this.isTongHopLichTuan
            ? data.filter(
                (item) =>
                  item.userDeptRoleView.id !== this.isTongHopLichTuan.id &&
                  item.countLichTuan > 0
              )
            : data.filter((item) => item.countLichTuan > 0);
          this.weeklyScheduleDaDangKy.countLichTuan = data.reduce(
            (acc, cur) => acc + cur.countLichTuan,
            0
          );
        } else if (data && data.length) {
          this.weeklyScheduleChuaDuyet.data = data[0];
          this.weeklyScheduleChuaDuyet.countLichTuan =
            this.weeklyScheduleChuaDuyet.data.countLichTuan;
        }
      } else if (state === "Hủy yêu cầu") {
        this.weeklyScheduleHuy.data = this.isTongHopLichTuan
          ? data.filter(
              (item) =>
                item.userDeptRoleView.id !== this.isTongHopLichTuan.id &&
                item.countLichTuan > 0
            )
          : data.filter((item) => item.countLichTuan > 0);
        this.weeklyScheduleHuy.countLichTuan = data.reduce(
          (acc, cur) => acc + cur.countLichTuan,
          0
        );
      }
    },

    loadDriverRequest(state, type) {
      // state=chopheduyet_state type=1 --- đã gửi đăng ký
      // state=chopheduyet_state --- chờ phê duyệt
      // state=dapheduyet_state  --- dã phê duyệt
      // state=huyyeucau_state   --- hủy
      let data = {
        fromCreateDate: null,
        toCreateDate: null,
        state,
        page: 0,
        size: 10,
        sort: "updateTime,desc",
      };
      if (type) {
        data.type = type;
      }
      dashBoardService.getDriverRequestDashBoard(data).then((res) => {
        this.setStateForDriverRequest(state, type, res.data);
      });
    },

    loadWeeklySchedule(state, type) {
      // state=Đã ban hành
      // state=Chưa phê duyệt
      // state=Hủy yêu cầu
      let data = {
        approveStatus: state,
        page: 0,
        size: 10,
        sort: "updateTime,desc",
      };
      if (type) {
        data.type = type;
      }
      dashBoardService.getWeeklyScheduleDashboard(data).then((res) => {
        this.setStateForWeeklySchedule(state, type, res.data);
      });
    },

    loadVanBanChoTiepNhan() {
      dashBoardService
        .getVanBanChoTiepNhanDashBoard({
          page: 0,
          size: 10,
          sort: "docDate,desc",
        })
        .then((response) => {
          let vanBanChoTiepNhanDashBoard = response.data;
          this.vanBanChoTiepNhan = vanBanChoTiepNhanDashBoard.docs;
          this.vanBanChoTiepNhanCount = vanBanChoTiepNhanDashBoard.docsCount;
        });
    },

    loadOutgoingDocsDashBoard() {
      dashBoardService
        .getOutgoingDocsDashBoard({
          page: 0,
          size: 10,
          sort: "createTime,desc",
        })
        .then((response) => {
          let outgoingDocsDashBoard = response.data;
          this.outgoingDocs = outgoingDocsDashBoard.docs;
          this.outgoingDocsCount = outgoingDocsDashBoard.docsCount;
          this.unreadOutgoingDocsCount = outgoingDocsDashBoard.unreadDocsCount;
        });
    },

    loadBanHanhOutgoingDocsDashBoard() {
      dashBoardService
        .getBanHanhOutgoingDocsDashBoard({
          page: 0,
          size: 10,
          sort: "docDate,desc",
        })
        .then((response) => {
          let outgoingDocsDashBoard = response.data;
          this.banHanhOutgoingDocs = outgoingDocsDashBoard.docs;
          this.banHanhOutgoingDocsCount = outgoingDocsDashBoard.docsCount;
        });
    },

    loadNotificationsDashBoard() {
      dashBoardService
        .getNotificationsDashBoard({
          page: 0,
          size: 50,
          sort: "createTime,desc",
        })
        .then((response) => {
          let notificationDashBoard = response.data;
          this.notifications = notificationDashBoard.notis;
          this.notificationsCount = notificationDashBoard.countNotis;
          this.notificationsUnreadCount =
            notificationDashBoard.countNotiUnreads;
          this.$store.commit("updateNotifies", notificationDashBoard);
        });
    },

    loadCheckedMenu(item) {
      menuConfigService
        .findAllByUserDeptRoleId(item.userDeptRole.id)
        .then((response) => {
          this.menuConfigs = response.data;
          this.checkedMenuCodes = h.collect(
            h.findAll(
              this.menuConfigs,
              (menuConfig) =>
                menuConfig.status == constants.MENU_CONFIG.STATUS.ACTIVE
            ),
            (menuConfig) => menuConfig.menuCode
          );
          h.each(this.checkedMenuCodes, (menuCode) => {
            switch (menuCode) {
              case constants.MENU_LIST.VB_DEN_CHOXULY:
                this.userDeptRoleIdForIncommingDoc = item.userDeptRole.id;
                this.isVisibleIncommingDoc = true;
                break;
              case constants.MENU_LIST.VB_DI_DUTHAO:
                this.userDeptRoleIdForOutgoingDoc = item.userDeptRole.id;
                this.isVisibleOutgoingDoc = true;
                break;
              case constants.MENU_LIST.VB_DI_DAPHATHANH:
                this.userDeptRoleIdForBanHanhOutgoingDoc = item.userDeptRole.id;
                this.isVisibleBanHanhOutgoingDoc = true;
                break;
              case constants.MENU_LIST.HANHCHINH:
                this.userDeptRoleIdForHanhChinh = item.userDeptRole.id;
                // this.isVisibleHanhChinh = true;
                break;
              case constants.MENU_LIST.CONGVIEC:
                this.userDeptRoleIdForCongViec = item.userDeptRole.id;
                this.isVisibleCongViec = true;
                break;
              case constants.MENU_LIST.VB_DEN_CHOTIEPNHAN:
                this.userDeptRoleIdForChoTiepNhan = item.userDeptRole.id;
                this.isVisibleChoTiepNhan = true;
                break;
              case constants.MENU_LIST.VB_DI_CHOBANHANH:
                this.userDeptRoleIdForChoBanHanh = item.userDeptRole.id;
                this.isVisibleChoBanHanh = true;
                break;
              /* case constants.MENU_LIST.THUVIEN_VANBANMAU:
                this.isVisibleVanBanMau = true;
                break; */
              case constants.MENU_LIST.HANHCHINH_DANGKYPHONGHOP:
                this.isVisiblePhongHop = true;
                break;
              case constants.MENU_LIST.HANHCHINH_YEUCAUDIEUXE:
                this.isVisibleDieuXe = true;
                break;
              case constants.MENU_LIST.HANHCHINH_DANGKYLICHTUAN:
                this.isVisibleLichTuan = true;
                break;
            }
          });
        });
    },
    setVisible() {
      h.each(this.dashboards, (item) => this.loadCheckedMenu(item));
    },

    viewListCVDuocGiao(item) {
      this.$store.commit("changeUserDeptRole", item.userDeptRoleView.id);
      this.$router.push({
        name: "detail-job",
        query: {
          taskStatuses: null,
          taskStatusFilter: null,
          viewType: "receiver",
        },
        params: {
          id: item.id,
          userDeptRoleId: item.userDeptRoleView.id,
        },
      });
    },

    viewListCVDaGiao(item) {
      this.$store.commit("changeUserDeptRole", item.userDeptRoleView.id);
      this.$router.push({
        name: "detail-job-assigned",
        query: {
          taskStatusFilter: "all",
          viewType: "assigner",
        },
        params: {
          id: item.id,
          userDeptRoleId: item.userDeptRoleView.id,
        },
      });
    },

    returnListJob(dataJob) {
      let jobs = [];
      if (dataJob["CHO_PHE_DUYET_DK"] && dataJob["CHO_PHE_DUYET_DK"].length) {
        dataJob["CHO_PHE_DUYET_DK"].map((item) => {
          if (item.tkTaskViews && item.tkTaskViews.length) {
            jobs = jobs.concat(
              ...item.tkTaskViews.map((x) => {
                return {
                  ...x,
                  quote: x.taskTitle,
                  userDeptRoleView: item.userDeptRoleView,
                };
              })
            );
          }
        });
      }
      if (dataJob["DANG_THUC_HIEN"] && dataJob["DANG_THUC_HIEN"].length) {
        dataJob["DANG_THUC_HIEN"].map((item) => {
          if (item.tkTaskViews && item.tkTaskViews.length) {
            jobs = jobs.concat(
              ...item.tkTaskViews.map((x) => {
                return {
                  ...x,
                  quote: x.taskTitle,
                  userDeptRoleView: item.userDeptRoleView,
                };
              })
            );
          }
        });
      }
      if (dataJob["HOAN_THANH"] && dataJob["HOAN_THANH"].length) {
        dataJob["HOAN_THANH"].map((item) => {
          if (item.tkTaskViews && item.tkTaskViews.length) {
            jobs = jobs.concat(
              ...item.tkTaskViews.map((x) => {
                return {
                  ...x,
                  quote: x.taskTitle,
                  userDeptRoleView: item.userDeptRoleView,
                };
              })
            );
          }
        });
      }
      if (dataJob["KET_THUC"] && dataJob["KET_THUC"].length) {
        dataJob["KET_THUC"].map((item) => {
          if (item.tkTaskViews && item.tkTaskViews.length) {
            jobs = jobs.concat(
              ...item.tkTaskViews.map((x) => {
                return {
                  ...x,
                  quote: x.taskTitle,
                  userDeptRoleView: item.userDeptRoleView,
                };
              })
            );
          }
        });
      }
      if (dataJob["HUY"] && dataJob["HUY"].length) {
        dataJob["HUY"].map((item) => {
          if (item.tkTaskViews && item.tkTaskViews.length) {
            jobs = jobs.concat(
              ...item.tkTaskViews.map((x) => {
                return {
                  ...x,
                  quote: x.taskTitle,
                  userDeptRoleView: item.userDeptRoleView,
                };
              })
            );
          }
        });
      }
      return jobs;
    },
  },
};
</script>

<style src="./dashboard.css" lang="css" scoped></style>



// WEBPACK FOOTER //
// src/views/dashboard/dashboard-index-v2.vue